import { BaseClient } from '../client';
import { TRevenda, shopkeeperMock1 } from '../shopkeeper';

export const getBuyerById = async ({ id }: { id: string }) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return shopkeeperMock1;
	// }

	try {
		const response = await BaseClient.get<TRevenda>(`/Admin/GetAdminRevendaPorId/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
